import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2>
              Client <span style={{ color: "#2F55C4" }}>Brief</span>
            </h2>
            <p>
              Maxim Olivson wanted an application that radically improves
              conventional business networking through digital scanning of IDs.
              This convenient, paperless approach would allow users to declutter
              and retain efficiency in a guilt-free, addictive way.
            </p>
            <h2>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#2F55C4" }}> 2018</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#2F55C4" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -{" "}
                <span style={{ color: "#2F55C4" }}> MOBILE APPLICATION</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
